import { type Column } from '@tanstack/react-table'
import { type CSSProperties } from 'react'

export const getCommonPinningStyles = <TData>(column: Column<TData>): CSSProperties => {
  const isPinned = column.getIsPinned()
  const isLastLeftPinnedColumn = isPinned === 'left' && column.getIsLastColumn('left')
  const isFirstRightPinnedColumn = isPinned === 'right' && column.getIsFirstColumn('right')

  return {
    borderRight: isLastLeftPinnedColumn ? '1px solid #979797' : undefined,
    borderLeft: isFirstRightPinnedColumn ? '1px solid #979797' : undefined,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `calc(${column.getAfter('right')}px - 14px)` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    zIndex: isPinned ? 1 : 0,
    marginRight: isFirstRightPinnedColumn ? '-14px' : undefined,
  }
}
